import { render, staticRenderFns } from "./cloneModal.vue?vue&type=template&id=4482e335&"
import script from "./cloneModal.vue?vue&type=script&lang=js&"
export * from "./cloneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports